import { useContext } from 'react';
import { UserMetadataContext } from '../../auth/components/UserMetadataProvider';
import { ControlledLoader } from './ControlledLoader';

export const UserGroupsLoader = ({ children }: { children: JSX.Element }) => {
  const { state } = useContext(UserMetadataContext);

  return <ControlledLoader loadingStatus={state.loadingStatus!}>{children}</ControlledLoader>;
};
